var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.radioIsActive()},[_c('input',{staticClass:"radio-input",attrs:{"type":"radio","disabled":_vm.disabled,"id":_vm.id},domProps:{"checked":_vm.isActive},on:{"click":_vm.onClick}}),(_vm.label)?_c('div',{staticClass:"radio-label"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }